class SubmenuOffcanvas extends HTMLElement {
  constructor() {
    super();
    this.mainSelector = this.getAttribute('main-selector') || '#mobileMenu';
    this.triggerSelector = this.getAttribute('trigger-selector') || '[data-subcanvas]';
    this.mainMenu = null;
  }

  connectedCallback() {
    this.mainMenu = document.querySelector(this.mainSelector);
    if (!this.mainMenu) return;
    this._init();
  }

  _init() {
    const triggers = document.querySelectorAll(this.triggerSelector);
    if (!triggers.length) return;

    triggers.forEach(trigger => {
      const targetSelector = trigger.dataset.subcanvas;
      const subcanvasEl = document.querySelector(targetSelector);
      if (!subcanvasEl) return;

      const subcanvas = bootstrap.Offcanvas.getOrCreateInstance(subcanvasEl);

      trigger.addEventListener('click', e => {
        e.preventDefault();
        this.mainMenu.classList.add('offcanvas-behind');
        subcanvas.show();
      });

      subcanvasEl.addEventListener('hidden.bs.offcanvas', () => {
        this.mainMenu.classList.remove('offcanvas-behind');
      });
    });
  }
}

customElements.define('submenu-offcanvas', SubmenuOffcanvas);
